import { BaseModel, Form, EntryTypes, Entry, OneColumnLayout, Resource } from '@ngx-resource-toolkit/core';
import { environment } from '../../../environments/environment';
import { LeaResource } from '../../shared/resource/lea.resource';
import { FormGroup } from '@angular/forms';
import { cycleFetchOptions, niveauFetchOptions, statutEleveFetchOptions } from '../../shared/resource/select-options';

@Resource({
    modes: {
        'default': {
            url: environment.proxyUrl + '/eleve',
            methods: LeaResource.methods,
        }
    }
})
@Form({
    'search': {
        layout: OneColumnLayout,

        onChanges: (value: EleveRechercheModel, form: FormGroup) => {
            const nom: string = form.value['nom'];
            if (nom) {
                form.patchValue({nom: nom.toUpperCase()},  {emitEvent: false});
            }
            const prenom: string = form.value['prenom'];
            if (prenom) {
                form.patchValue({prenom: prenom.charAt(0).toUpperCase() + prenom.slice(1).toLowerCase()},  {emitEvent: false});
            }
        }
    },
    'discipline': {
        layout: OneColumnLayout
    }
})
export class EleveRechercheModel extends BaseModel {
    @Entry({
        base: {
            hidden: true
        },
        'search': {},
        'discipline': {},
    })
    _explicitType = 'EleveSearchCriteria';

    @Entry({
        base: {
            hidden: true
        },
        'search': {},
        'discipline': {},
    })
    anneeScolaire: string;

    @Entry({
        base: {
            type: EntryTypes.NUMBER,
            css: {
                group: 'col-xs-6',
                label: 'col-xs-4',
                input: 'col-xs-8'
            },
            placeholder: 'Numéro',
            label: 'N°',
        },
        'search': {},
        'discipline': {},
    })
    id: number;

    @Entry({
        base: {
            type: EntryTypes.SELECT,
            label: 'Statut',
            css: {
                group: 'col-xs-6',
                label: 'col-xs-4',
                input: 'col-xs-8'
            },
            // transform: (value) => { return 0 },
            fetchOptions: statutEleveFetchOptions,
        },
        'search': {},
        'discipline': {},
    })
    statut: number;

    @Entry({
        base: {
            type: EntryTypes.TEXT,
            css: {
                group: 'col-xs-6',
                label: 'col-xs-4',
                input: 'col-xs-8'
            },
            label: 'Nom',
        },
        'search': {},
        'discipline': {},
    })
    nom: string;

    @Entry({
        base: {
            type: EntryTypes.TEXT,
            css: {
                group: 'col-xs-6',
                label: 'col-xs-4',
                input: 'col-xs-8'
            },
            label: 'Prénom',
        },
        'search': {},
        'discipline': {},
    })
    prenom: string;

    @Entry({
        base: {

        },
        'search': {
            type: EntryTypes.TEXT,
            css: {
                group: 'col-xs-12',
                label: 'col-xs-2',
                input: 'col-xs-10'
            },
            label: 'Courriel',
        },
        'discipline': {
            type: EntryTypes.TEXT,
            css: {
                group: 'col-xs-12',
                label: 'col-xs-2',
                input: 'col-xs-10'
            },
            label: 'Courriel',
        },
    })
    email: string;

    @Entry({
        base: {
            type: EntryTypes.SELECT,
            label: 'Age',
            css: {
                group: 'col-xs-4 col-md-3 no-padding-right',
                label: 'col-xs-6 col-md-8',
                input: 'col-xs-6 col-md-4 no-padding-right'
            },
            transform: (value) => { return 0 },
            options: [{
                value: null,
                label: '',
            }, {
                value: '<',
                label: '<',
            }, {
                value: '<=',
                label: '≤',
            }, {
                value: '=',
                label: '=',
            }, {
                value: '>=',
                label: '≥',
            }, {
                value: '>',
                label: '>',
            }]
        },
        'search': {},
        'discipline': {},
    })
    comparateurAge: number;

    @Entry({
        base: {
            type: EntryTypes.NUMBER,
            css: {
                group: 'col-xs-4 col-md-3 no-padding-left',
                // label: 'col-xs-4',
                input: 'col-xs-12 no-padding-left'
            },
            placeholder: 'Age'
        },
        'search': {},
        'discipline': {},
    })
    age: number;

    @Entry({
        base: {
            type: EntryTypes.CHECKBOX,
            css: {
                group: 'col-xs-4 col-md-3',
            },
            options: [{
                value: true,
                label: 'Sans date de naissance'
            }],
        },
        'search': {},
        'discipline': {},
    })
    sansDateNaissance: boolean;

    @Entry({
        base: {
            type: EntryTypes.SELECT,
            label: 'Discipline',
            css: {
                group: 'col-xs-12 col-lg-6',
                label: 'col-xs-2 col-lg-4',
                input: 'col-xs-10 col-lg-8'
            },
        },
        'search': {},
        'discipline': {},
    })
    idDiscipline: number;

    @Entry({
        base: {
            type: EntryTypes.SELECT,
            label: 'Cycle',
            css: {
                group: 'col-xs-12 col-lg-6',
                label: 'col-xs-2 col-lg-4',
                input: 'col-xs-10 col-lg-8'
            },
        },
        'search': {
            fetchOptions: cycleFetchOptions,
        },
        'discipline': {},
    })
    idCycle: number;

    @Entry({
        base: {
            type: EntryTypes.SELECT,
            label: 'Niveau',
            css: {
                group: 'col-xs-12 col-lg-6',
                label: 'col-xs-2 col-lg-4',
                input: 'col-xs-10 col-lg-8'
            },
        },
        'search': {
            fetchOptions: niveauFetchOptions,
        },
        'discipline': {},
    })
    idNiveau: number;

    @Entry({
        base: {
            type: EntryTypes.SELECT,
            label: 'Professeur',
            css: {
                group: 'col-xs-12 col-lg-6',
                label: 'col-xs-2 col-lg-4',
                input: 'col-xs-10 col-lg-8'
            },
        },
        'search': {},
        'discipline': {},
    })
    idProfesseur: number;

    @Entry({
        base: {
            type: EntryTypes.SELECT,
            label: 'Cursus / Hors cursus',
            css: {
                group: 'col-xs-6 col-lg-6',
                label: 'col-xs-4 col-lg-4',
                input: 'col-xs-8 col-lg-8'
            },
            options: [{
                value: 0,
                label: '',
            },{
                value: 1,
                label: 'Hors cursus',
            },{
                value: -1,
                label: 'Dans cursus',
            }]
        },
        'search': {},
        'discipline': {},
    })
    horsCursus: number;

    @Entry({
        base: {
            type: EntryTypes.SELECT,
            label: 'Accord multimédia',
            css: {
                group: 'col-xs-6 col-lg-6',
                label: 'col-xs-4 col-lg-4',
                input: 'col-xs-8 col-lg-8'
            },
            options: [{
                value: 0,
                label: 'Indifférent',
            }, {
                value: 1,
                label: 'Oui',
            }, {
                value: -1,
                label: 'Non',
            }]
        },
        'search': {},
        'discipline': {},
    })
    accordMedia: Number; //1=oui, -1=non, sinon critere non utilise;

    @Entry({
        base: {
            type: EntryTypes.CHECKBOX,
            css: {
                group: 'col-xs-6 col-lg-3',
            },
            // checked: true, //TODO: integration
            options: [{
                value: true,
                label: 'Local'
            }],
        },
        'search': {},
        'discipline': {},
    })
    isLocal: boolean = true;

    @Entry({
        base: {
            type: EntryTypes.CHECKBOX,
            css: {
                group: 'col-xs-6 col-lg-3',
            },
            // checked: true, // TODO: integration
            options: [{
                value: true,
                    label: 'Local élargi'
            }],
        },
        'search': {},
        'discipline': {},
    })
    isLocalElargi: boolean = true ;

    @Entry({
        base: {
            type: EntryTypes.CHECKBOX,
            css: {
                group: 'col-xs-6 col-lg-3',
            },
            options: [{
                value: true,
                label: 'Exterieur'
            }],
        },
        'search': {},
        'discipline': {},
    })
    isExterieur: boolean = true;

    @Entry({
        base: {
            type: EntryTypes.CHECKBOX,
            css: {
                group: 'col-xs-6 col-lg-3',
            },
            options: [{
                value: true,
                label: 'Anciens élèves'
            }],
        },
        'search': {},
        'discipline': {},
    })
    avecElevesInactifs: boolean;

    @Entry({
        base: {
            type: EntryTypes.SELECT,
            label: 'FM',
            css: {
                group: 'col-xs-6 col-lg-6',
                label: 'col-xs-4 col-lg-4',
                input: 'col-xs-8 col-lg-8'
            },
            transform: (value) => { return 0 },
            options: [{
                value: 0,
                label: '',
            },{
                value: 1,
                label: 'Avec',
            },{
                value: -1,
                label: 'Sans',
            }]
        },
        'search': {},
        'discipline': {},
    })
    avecCoursFM: number;

    @Entry({
        base: {
            type: EntryTypes.SELECT,
            label: 'FI',
            css: {
                group: 'col-xs-6 col-lg-6',
                label: 'col-xs-4 col-lg-4',
                input: 'col-xs-8 col-lg-8'
            },
            transform: (value) => { return 0 },
            options: [{
                value: 0,
                label: '',
            },{
                value: 1,
                label: 'Avec',
            },{
                value: -1,
                label: 'Sans',
            }]
        },
        'search': {},
        'discipline': {},
    })
    avecCoursFI: number;

    @Entry({
        base: {
            type: EntryTypes.SELECT,
            label: 'Danse',
            css: {
                group: 'col-xs-6 col-lg-6',
                label: 'col-xs-4 col-lg-4',
                input: 'col-xs-8 col-lg-8'
            },
            transform: (value) => { return 0 },
            options: [{
                value: 0,
                label: '',
            },{
                value: 1,
                label: 'Avec',
            },{
                value: -1,
                label: 'Sans',
            }]
        },
        'search': {},
        'discipline': {},
    })
    avecCoursDanse: number;

    @Entry({
        base: {
            type: EntryTypes.SELECT,
            label: 'PC',
            css: {
                group: 'col-xs-6 col-lg-6',
                label: 'col-xs-4 col-lg-4',
                input: 'col-xs-8 col-lg-8'
            },
            transform: (value) => { return 0 },
            options: [{
                value: 0,
                label: '',
            },{
                value: 1,
                label: 'Avec',
            },{
                value: -1,
                label: 'Sans',
            }]
        },
        'search': {},
        'discipline': {},
    })
    avecCoursPC: number;

    @Entry({
        base: {
            type: EntryTypes.SELECT,
            label: 'Cours',
            css: {
                group: 'col-xs-6 col-lg-6',
                label: 'col-xs-4 col-lg-4',
                input: 'col-xs-8 col-lg-8'
            },
            transform: (value) => { return 0 },
            options: [{
                value: 0,
                label: '',
            },{
                value: 1,
                label: 'Avec',
            },{
                value: -1,
                label: 'Sans',
            }]
        },
        'search': {},
        'discipline': {},
    })
    avecCours: number;

    @Entry({
        base: {
            type: EntryTypes.SELECT,
            label: 'COM',
            css: {
                group: 'col-xs-6 col-lg-6',
                label: 'col-xs-4 col-lg-4',
                input: 'col-xs-8 col-lg-8'
            },
            transform: (value) => { return 0 },
            options: [{
                value: 0,
                label: '',
            },{
                value: 1,
                label: 'Avec',
            },{
                value: -1,
                label: 'Sans',
            }],
            hidden: true,
        },
        'search': {},
        'discipline': {},
    })
    bool_01: number;

    @Entry({
        base: {
            type: EntryTypes.SELECT,
            label: 'Parc. pers.',
            css: {
                group: 'col-xs-6 col-lg-6',
                label: 'col-xs-4 col-lg-4',
                input: 'col-xs-8 col-lg-8'
            },
            transform: (value) => { return 0 },
            options: [{
                value: 0,
                label: '',
            },{
                value: 1,
                label: 'Avec',
            },{
                value: -1,
                label: 'Sans',
            }],
            hidden: true,
        },
        'search': {},
        'discipline': {},
    })
    bool_02: number;

    constructor(data?) {
        super();
        Object.assign(this, data);
    }

}



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/eleve/models/eleve-recherche.model.ts